import { useForm } from 'react-hook-form';

import { zodResolver } from '@hookform/resolvers/zod';

import { UserFilterForm, UserFilterSchema } from '@t/user/components/filter/field-values.schema';

export const useCreateUserFilterForm = () => {
  const methods = useForm<UserFilterForm>({
    mode: 'onChange',
    resolver: zodResolver(UserFilterSchema),
    reValidateMode: 'onChange',
  });

  return methods;
};
